import React from 'react';
import PropTypes from 'prop-types';
import CwTreeViewNode, { treeViewNodeShape } from './CwTreeViewNode';
import IconPath from 'src/utils/IconPath';

const CwTreeView = (props) => {

  const getItemCollapsed = (item) => {
    // isCollapsed flag defaults to true
    return item.isCollapsed === undefined ? true : item.isCollapsed;
  };

  const getUpdatedItems = (item, selectedItem) => {
    // recursively build updated children items
    const children = item.children ? item.children.map((child) => {
      return getUpdatedItems(child, selectedItem);
    }) : undefined;

    const isSelectedItem = (item.id === selectedItem.id); // use unique id to determine selection
    item.isSelected = isSelectedItem; // explicitly set for all items. selected item should be mutually exclusive
    item.isCollapsed = isSelectedItem ? !selectedItem.isCollapsed : getItemCollapsed(item); // only toggle for selected item, else use default
    item.children = children; // nested updated children items

    return item;
  };

  const handleClick = (selectedItem) => {
    // get updated treeview value with changes from selection
    const updatedItems = props.value.map((item) => {
      return getUpdatedItems(item, selectedItem);
    });

    // fire onChange with full updated treeview value
    if (props.onChange) {
      props.onChange(updatedItems);
    }

    // fire onItemSelected with just selected id
    // to avoid consumer having to iterate through
    // full treeview value to find selected item
    if (props.onItemSelected) {
      props.onItemSelected(selectedItem.id);
    }
  };

  const getTreeViewNode = (item) => {
    // recursively build children treeviewnodes
    const children = item.children ? item.children.map((child) => {
      return getTreeViewNode(child);
    }) : undefined;

    // create full value prop object for CwTreeViewNode
    const value = {
      id: item.id,
      name: item.name,
      isSelected: item.isSelected === undefined ? false : item.isSelected, // isSelected flag defaults to false
      isCollapsed: getItemCollapsed(item),
      children, // nested CwTreeViewNode elements
    };

    return (
      <CwTreeViewNode
        key={value.id}
        collapseIcon={props.collapseIcon}
        expandIcon={props.expandIcon}
        value={value}
        onClick={handleClick}>
        {children}
      </CwTreeViewNode>
    );
  };

  // iterate through value prop and create treeviewnode elements
  const treeView = props.value.map((item) => {
    return getTreeViewNode(item);
  });

  return (
    <div style={props.style} className={props.className}>
      {treeView}
    </div>
  );
};

// recursive treeviewnode proptype shape
let nodeShape = { ...treeViewNodeShape };
nodeShape.children = PropTypes.arrayOf(PropTypes.shape(nodeShape));

CwTreeView.propTypes = {
  /**
   * Collapse icon to display when expanded for treeviewnode with children
   */
  collapseIcon: PropTypes.string,
  /**
   * Expand icon to display when collapsed for treeviewnode with children
   */
  expandIcon: PropTypes.string,
  /**
   * Treeview layout data
   */
  value: PropTypes.arrayOf(PropTypes.shape(nodeShape)),
  /**
   * Fires entire updated value layout whenever an item is selected
   */
  onChange: PropTypes.func,
  /**
   * Fires selected id whenever an item is selected
   */
  onItemSelected: PropTypes.func,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
};

CwTreeView.defaultProps = {
  collapseIcon: IconPath.get('Action_Tree_Collapse'),
  expandIcon: IconPath.get('Action_Tree_Expand')
};

export default CwTreeView;


// WEBPACK FOOTER //
// ./src/components/cwtreeview/CwTreeView.jsx